import { render, staticRenderFns } from "./Create-Quotation.vue?vue&type=template&id=278ec664&scoped=true"
import script from "./Create-Quotation.vue?vue&type=script&lang=js"
export * from "./Create-Quotation.vue?vue&type=script&lang=js"
import style0 from "./Create-Quotation.vue?vue&type=style&index=0&id=278ec664&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278ec664",
  null
  
)

export default component.exports